import { Bets, IMakeBet } from '../types';
import { init, last } from 'ramda';
import { numberOnTheRacetrack, BetsTypes } from './const';

const moveLastNumberInTop = (arr: string[]) => [last(arr), ...init(arr)];

// @ts-ignore
export const raceTrackAreaData = moveLastNumberInTop(numberOnTheRacetrack).map((item: string) => ({
  label: item,
  selector: [item],
  type: BetsTypes.raceTrackStraight,
  bet: 0,
}));

const { tier, orphelins, voisins, jeuZero } = BetsTypes;

export const sideBets = new Set([tier, orphelins, voisins, jeuZero]);

// @ts-ignore
export const neighboursAreaData = [...sideBets].map((item: string) =>
  item === jeuZero
    ? {
        selector: [item],
        label: item,
        type: BetsTypes.jeuZero,
      }
    : {
        selector: [item],
        label: item,
        // @ts-ignore
        type: BetsTypes[item],
      },
);

// @ts-ignore
export const raceTrackBets = new Set([...sideBets, BetsTypes.raceTrackStraight]);

const orphelinsBets: IMakeBet[] = [
  {
    type: Bets.straight,
    selector: ['1'],
    chips: 1,
  },
  {
    type: Bets.split,
    selector: ['6', '9'],
    chips: 1,
  },
  {
    type: Bets.split,
    selector: ['14', '17'],
    chips: 1,
  },
  {
    type: Bets.split,
    selector: ['17', '20'],
    chips: 1,
  },
  {
    type: Bets.split,
    selector: ['31', '34'],
    chips: 1,
  },
];

export const voisinsBets: IMakeBet[] = [
  {
    type: Bets.street,
    selector: ['0', '2', '3'],
    chips: 2,
  },
  {
    type: Bets.split,
    selector: ['4', '7'],
    chips: 1,
  },
  {
    type: Bets.split,
    selector: ['12', '15'],
    chips: 1,
  },
  {
    type: Bets.split,
    selector: ['18', '21'],
    chips: 1,
  },
  {
    type: Bets.split,
    selector: ['19', '22'],
    chips: 1,
  },
  {
    type: Bets.corner,
    selector: ['25', '26', '28', '29'],
    chips: 2,
  },
  {
    type: Bets.split,
    selector: ['32', '35'],
    chips: 1,
  },
];

const tierBets: IMakeBet[] = [
  {
    type: Bets.split,
    selector: ['5', '8'],
    chips: 1,
  },
  {
    type: Bets.split,
    selector: ['10', '11'],
    chips: 1,
  },
  {
    type: Bets.split,
    selector: ['13', '16'],
    chips: 1,
  },
  {
    type: Bets.split,
    selector: ['23', '24'],
    chips: 1,
  },
  {
    type: Bets.split,
    selector: ['27', '30'],
    chips: 1,
  },
  {
    type: Bets.split,
    selector: ['33', '36'],
    chips: 1,
  },
];

const zeroBets: IMakeBet[] = [
  {
    type: Bets.split,
    selector: ['0', '3'],
    chips: 1,
  },
  {
    type: Bets.split,
    selector: ['12', '15'],
    chips: 1,
  },
  {
    type: Bets.straight,
    selector: ['26'],
    chips: 1,
  },
  {
    type: Bets.split,
    selector: ['32', '35'],
    chips: 1,
  },
];

export const sideBetsSet = {
  [BetsTypes.orphelins]: orphelinsBets,
  [BetsTypes.voisins]: voisinsBets,
  [BetsTypes.tier]: tierBets,
  [BetsTypes.jeuZero]: zeroBets,
};

export const neighboursChipsCount = {
  [BetsTypes.orphelins]: 5,
  [BetsTypes.voisins]: 9,
  [BetsTypes.tier]: 6,
  [BetsTypes.jeuZero]: 4,
};

export const neighboursCountLimit = {
  min: 0,
  max: 9,
};
